var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "last-step" },
    [
      _vm.error
        ? [
            _c("h3", [_vm._v("Fehler bei der Anlage")]),
            _vm._v(" "),
            _c("div", [
              _vm._v(
                "\n\t\t\tDie Anlage deines Anonymprofils hat leider nicht funktioniert. Bitte gehe einen Schritt zurück und prüfe\n\t\t\tdeine Daten (vor allem die E-Mail-Adresse).\n\t\t"
              )
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "mt-3" },
              [
                _c("Button", {
                  attrs: { text: "Zurück", icon: "pencil" },
                  on: {
                    click: function($event) {
                      return _vm.$emit("goBack")
                    }
                  }
                })
              ],
              1
            )
          ]
        : [
            _vm.loading
              ? [
                  _c("Loading", { attrs: { "fun-fact": false } }),
                  _vm._v(" "),
                  _vm._m(0)
                ]
              : [
                  _c("h1", [_vm._v(_vm._s(_vm.title))]),
                  _vm._v(" "),
                  _c("div", { staticClass: "intro" }, [
                    _c("p", [
                      _vm._v(
                        "\n\t\t\t\t\tWir haben dir ein E-Mail gesendet an"
                      ),
                      _c("br"),
                      _vm._v(" "),
                      _c("span", { staticClass: "pl-4 color-primary" }, [
                        _vm._v(_vm._s(_vm.emailToShow))
                      ]),
                      _c("br")
                    ]),
                    _vm._v(" "),
                    _c("p", [
                      _vm._v(
                        "Bitte klicke im E-Mail den Link, um dein Profil zu aktivieren und passende Jobs zu finden."
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _vm.application
                    ? [
                        _c("div", { staticClass: "action-container" }, [
                          _c("div", [
                            _vm._v(
                              "Kein E-Mail erhalten und im Spamordner/Junkordner ist kein E-Mail gekommen?"
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "pl-4" },
                            [
                              _vm.resending
                                ? _c("Loading", {
                                    attrs: {
                                      small: "",
                                      inline: "",
                                      "block-element": false
                                    }
                                  })
                                : _c(
                                    "a",
                                    {
                                      staticClass: "icon-link",
                                      attrs: { href: "#" },
                                      on: {
                                        click: function($event) {
                                          $event.preventDefault()
                                          return _vm.resend.apply(
                                            null,
                                            arguments
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _c("Icon", { attrs: { icon: "mail" } }),
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\tNeu senden\n\t\t\t\t\t\t"
                                      )
                                    ],
                                    1
                                  )
                            ],
                            1
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "action-container" }, [
                          _c("div", [_vm._v("E-Mail Adresse falsch?")]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "pl-4" },
                            [
                              _c(
                                "a",
                                {
                                  staticClass: "icon-link",
                                  attrs: { href: "#" },
                                  on: {
                                    click: function($event) {
                                      $event.preventDefault()
                                      _vm.correctEmail = true
                                    }
                                  }
                                },
                                [
                                  _c("Icon", { attrs: { icon: "settings" } }),
                                  _vm._v(
                                    "\n\t\t\t\t\t\t\tE-Mail Adresse bearbeiten\n\t\t\t\t\t\t"
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _vm.correctEmail
                                ? _c(
                                    "FormGroup",
                                    {
                                      attrs: {
                                        state: _vm.emailValid,
                                        "invalid-feedback": _vm.emailError,
                                        "feedback-beneath": ""
                                      }
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "correct-email" },
                                        [
                                          _c(
                                            "div",
                                            [
                                              _c("b-input", {
                                                attrs: { type: "email" },
                                                model: {
                                                  value: _vm.email,
                                                  callback: function($$v) {
                                                    _vm.email = $$v
                                                  },
                                                  expression: "email"
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            [
                                              _c("Button", {
                                                attrs: {
                                                  text: "E-Mail bestätigen",
                                                  icon: "checkmark",
                                                  disabled:
                                                    !_vm.emailValid ||
                                                    _vm.resending
                                                },
                                                on: { click: _vm.resend }
                                              })
                                            ],
                                            1
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        ])
                      ]
                    : _vm._e()
                ]
          ]
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "mt-4 text-center" }, [
      _c("h3", [
        _vm._v(
          "Dein Anonymprofil wird angelegt, das dauert ein paar Augenblicke."
        ),
        _c("br"),
        _vm._v("Bitte schließe diese Seite\n\t\t\t\t\tnicht.")
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }